// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "ba9056f2" + ".chunk.css";
};